<template>
  <v-container>
    <v-main>
      <section id="hero">
        <v-row no-gutters>
          <v-img
            :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            src="@/assets/pck_iz_zraka_3.jpg"
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row
                  align="center"
                  class="white--text mx-auto"
                  justify="center"
                >
                  <v-col
                    class="white--text text-center"
                    cols="12"
                    tag="h1"
                  >

                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                      class="font-weight-black"
                    >
                      CHRONOS ENERGIJA
                    </span>

                    <br>

                    <span
                    :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                      class="font-weight-light"
                    >
                      high-tech for environment
                    </span>

                  </v-col>

                  <v-btn
                    class="align-self-end"
                    fab
                    outlined
                    @click="$vuetify.goTo('#about-us')"
                  >
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>

      <section id="about-us">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">ABOUT US</h2>

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
            CHRONOS ENERGIJA is a team of engineers and professionals, dedicated to protecting environment since 1985. Our goal is development of advanced technology to solve the most complex problems of wastewater, solid waste, air polution and urban life through facilitating co-operation of people by using advanced monitoring and control technology. Our in-depth understanding of processes and modern solutions alows us to tackle and resolve the most difficult problems.
          </v-responsive>

          <v-avatar
            class="elevation-12 mb-12"
            size="128"
          >
            <a href="https://cn.hidro-l.com"><v-img src="@/assets/chronos_wheel.png"></v-img></a>
          </v-avatar>

          <div></div>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section
        id="features"
        class="grey lighten-3"
      >
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">OUR WORK</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ icon, title, link, text }, i) in features"
              :key="i"
              cols="12"
              md="4"
            >
              <v-card
                class="py-12 px-4"
                color="grey lighten-5"
                flat
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar
                      color="primary"
                      size="88"
                    >
                    <router-link :to="link">
                      <v-icon
                        large
                        v-text="icon"
                      ></v-icon>
                    </router-link>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="title"
                ></v-card-title>

                <v-card-text
                  class="subtitle-1"
                  v-text="text"
                >
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
        >
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col
                v-for="[value, title] of stats"
                :key="title"
                cols="12"
                md="4"
              >
                <div class="text-center">
                  <div
                    class="display-3 font-weight-black mb-4"
                    v-text="value"
                  ></div>

                  <div
                    class="title font-weight-regular text-uppercase"
                    v-text="title"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>


      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Contact Us</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-theme-provider light>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  flat
                  label="Subject*"
                  solo
                  v-model="subject"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  flat
                  label="Message*"
                  solo
                  v-model="message"
                ></v-textarea>
              </v-col>

              <v-col
                class="mx-auto"
                cols="auto"
              >
                <v-btn
                  color="accent"
                  x-large
                  @click="sendEmail"
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-theme-provider>
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-main>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — CHRONOS ENERGIJA, d.o.o., Levstikov trg 8, 1000 Ljubljana, Slovenia, info@chronos.si
      </div>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  name: 'Main',
  data: () => {
    return {
      name: "",
      email: "",
      subject: "",
      message: "",
      features: [
        {
          icon: 'mdi-pipe',
          title: 'Infrastructure',
          link: '/infrastructure',
          text: "Our team has designed and built various infrastructure project, from small wastewater treatment plants to complex industrial areas. We're aware of details but never forget the big picture.",
        },
        {
          icon: 'mdi-desktop-tower-monitor',
          title: 'Technology',
          link: '/equipment',
          text: "We've developed custom technology for particular tasks for water and air polution reduction and keep improving our state-of-the-art process control & monitoring devices.",
        },
        {
          icon: 'mdi-floor-plan',
          title: 'Planning & Design',
          link: '/development',
          text: "Our track record of strategic planning includes environmental feasibility studies, climate change reports, regional development plans for business and agriculture and many more.",
        },
      ],
      stats: [
        ['15GB', 'data received from our installations'],
        ['AI', 'artificial intelligence and data mining'],
        ['35', 'years of experience'],
      ],
    }
  },
  methods: {
    sendEmail() {
      document.location.href = "mailto:info@chronos.si?subject="
        + encodeURIComponent(this.subject)
        + "&body=" + encodeURIComponent(this.message);
    }
  } 
}
</script>
